const ALLOWED_IFRAME_HOSTNAME_REGEXES = [
  /^open\.spotify\.com$/,
  /^w\.soundcloud\.com$/,
  /^www\.youtube\.com$/,
  /^player\.vimeo\.com$/,
  /^([a-z0-9-]+\.)*disco\.ac$/,
  /^www\.tiktok\.com$/,
  /^facebook\.com$/,
  /^instagram\.com$/,
  /^platform\.twitter\.com$/,
  /^platform\.x\.com$/,
  /^([a-z0-9-]+\.)*bandsintown\.ac$/,
  /^seated\.com$/,
  /^player\.vimeo\.com$/,
  /^player\.twitch\.tv$/,
  /^audiomack\.com$/,
  /^snapchat\.com$/,
  /^threads\.com$/,
]

export const extractAndValidateIframe = (html: string) => {
  const temporaryDiv = document.createElement('div')
  temporaryDiv.innerHTML = html
  const iframe = temporaryDiv.querySelector('iframe')

  if (!iframe) return ''

  try {
    const source = iframe.getAttribute('src')
    if (!source) return ''

    const url = new URL(source)
    const hostname = url.hostname
    const isAllowed = ALLOWED_IFRAME_HOSTNAME_REGEXES.some(regex => regex.test(hostname))
    if (!isAllowed) return ''

    // Whitelist attributes
    const allowedAttributes = [
      'src',
      'width',
      'height',
      'frameborder',
      'allow',
      'allowfullscreen',
      'loading',
    ]

    const safeIframe = document.createElement('iframe')
    for (const attribute of allowedAttributes) {
      const value = iframe.getAttribute(attribute)
      if (value) safeIframe.setAttribute(attribute, value)
    }

    safeIframe.setAttribute('sandbox', 'allow-same-origin allow-scripts allow-popups')

    return safeIframe.outerHTML
  } catch {
    return ''
  }
}
